import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getImmobilizationSelector } from '../selectors'
import { saveImmobilization } from '../store/immobilization.actions'
import { ImmobilizationConstants } from '../store/immobilization.constants'
import { IImmobilizationState } from '../store/immobilization.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const immobilizationState: IImmobilizationState = yield select(getImmobilizationSelector)
  const { successfulAttempt } = immobilizationState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.immobilizationStateList && pcrDoc.patient?.immobilizationStateList.length) {
        const index = pcrDoc.patient?.immobilizationStateList?.findIndex(
          (immobilization) => immobilization.key === immobilizationState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.immobilizationStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveImmobilization())
          }
        }
      } else {
        yield put(saveImmobilization())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([ImmobilizationConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
